import { AuthenticatedLayout } from "../../../layouts";
import { CRAReport } from "../../../components/Reports/CRAReport";
import { FC } from "react";

export interface ICRAReportSetupPage {}

export const CRAReportSetupPage: FC<ICRAReportSetupPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="CRA Report"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<CRAReport />}
		/>
	);
};
